<template>
	<div class="arrow-accordion">
		<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
				<g clip-path="url(#clip0_627_5260)">
					<path d="M8.2384 12.943L0.666016 5.13798L1.58063 4.19531L8.2384 11.057L14.8962 4.19531L15.8108 5.13798L8.2384 12.943Z" fill="black"/>
				</g>
				<defs>
					<clipPath id="clip0_627_5260">
					<rect width="15.5238" height="16" fill="white" transform="translate(0.476562)"/>
					</clipPath>
				</defs>
		</svg>
	</div>
</template>

<script>
export default {
	name: "accordion-arrow-icon",
};
</script>
